import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { ProofBarItem } from '../../../lib/social-proof';
import { FeatureIcon } from '../../ui/FeatureIcon';
import { InfoCard } from '../../ui/InfoCard';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GroupIcon from '@mui/icons-material/Group';
import SavingsIcon from '@mui/icons-material/Savings';
import InsightsIcon from '@mui/icons-material/Insights';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// Fallback icon
import StarIcon from '@mui/icons-material/Star';

// Map string IDs to Icons
const ICON_MAP: Record<string, React.ReactNode> = {
    schedule: <ScheduleIcon />,
    trending_up: <TrendingUpIcon />,
    account_balance_wallet: <AccountBalanceWalletIcon />,
    accessibility_new: <AccessibilityNewIcon />,
    check_circle: <CheckCircleIcon />,
    group: <GroupIcon />,
    savings: <SavingsIcon />,
    insights: <InsightsIcon />,
    receipt_long: <ReceiptLongIcon />,
};

interface ProofBarProps {
    items: ProofBarItem[];
}

export function ProofBar({ items }: ProofBarProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={{ py: 2 }}>
            <Grid container spacing={isMobile ? 0.5 : 2}>
                {items.map((item, index) => (
                    <Grid item xs={12} md={4} key={index}>
                        <InfoCard
                            title={item.highlight}
                            titleColor={theme.palette.audience.clinician[900]}
                            hoverEffect={false}
                            tagline={isMobile ? "" : item.label}
                            description={item.text}
                            taglineColor="primary.main"
                            variant="outlined"
                            padding={2}
                            titleSize={isMobile ? "small" : "medium"}
                            orientation="horizontal"
                            icon={
                                <FeatureIcon
                                    icon={ICON_MAP[item.icon] || <StarIcon />}
                                    size={isMobile ? "small" : "medium"}
                                    variant="circle"
                                    color={theme.palette.primary.main}
                                />
                            }
                            sx={{
                                height: '100%',
                                border: 'none',

                                bgcolor: 'transparent',
                                px: 0,
                            }}
                            centered
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
